<template>
  <div class="widget-details">
    <template v-if="!updatedData.widgetType">
      <p class="widget-info">
        This widget adds your platform FAQs as a content accordion which are
        defined in your global settings.
      </p>

      <v-btn class="accent" v-if="!updatedData.widgetType" @click="initialise()"
        >Use this widget</v-btn
      >
    </template>

    <div class="widget-fieldset" v-else>
      <label class="label">Title</label>
      <v-text-field
        id="widgetData.title"
        solo
        flat
        v-model="updatedData.widgetData.title"
      >
      </v-text-field>

      <!-- THE BELOW IS NOT IN USE -->
      <!-- <label class="label">Description</label>
      <v-text-field
        id="widgetData.title"
        solo
        flat
        v-model="updatedData.widgetData.content">
      </v-text-field> -->

      <label class="label">Style</label>
      <v-select
        id="widgetData.style"
        :items="styleOptions"
        solo
        flat
        v-model="updatedData.widgetData.style"
      >
      </v-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoFaqs",

  watch: {
    updatedData: {
      handler: function () {
        this.updatedContent();
      },
      deep: true,
    },
  },

  props: {
    editData: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    styleOptions: [
      { text: "Light Mode", value: "light" },
      { text: "Dark Mode", value: "dark" },
    ],
    updatedData: {
      title: null,
      content: null,
      style: null, // Background colour - light || dark
    },
  }),

  mounted() {
    this.updatedData = JSON.parse(JSON.stringify(this.editData));
  },

  methods: {
    initialise() {
      this.updatedData.widgetType = "VideoFaqs";
      this.updatedData.widgetName = "Video Faqs";
      this.updatedData.widgetID = this.$uuid.v1();
      this.updatedData.widgetData = {
        title: null,
        content: null,
        style: null, // Background colour - light || dark
      };
      this.$emit("initialised");
    },

    updatedContent() {
      this.$emit("updatedWidget", this.updatedData);
    },
  },
};
</script>

<style scoped lang='scss'>
</style>
